import { FiInfo } from "../../assets/icons/vander";
import { TableEvaluationPatient, TableEvaluationEndingPatient } from "./";

export const EvaluationPatient = ({ evaluations, assessment }) => {
  return (
    <>
      <div className="card border-0 shadow rounded p-4 mb-4">
        <h6 className="mb-0">Encuesta: {assessment.title}</h6>
        <p className="text-muted mb-0 text-truncate small">
          {assessment.description}
        </p>
      </div>

      {evaluations?.EVALUATION ? (
        <TableEvaluationPatient evaluations={evaluations.EVALUATION} />
      ) : (
        <div className="alert bg-soft-primary fw-medium" role="alert">
          <FiInfo className="fs-5 align-middle me-1" /> El paciente no ha
          respondido a la encuesta
        </div>
      )}

      {evaluations?.ENDING ? (
        <>
          <h6 className="mt-4">Encuesta de satisfacción:</h6>
          <TableEvaluationEndingPatient evaluations={evaluations.ENDING} />
        </>
      ) : (
        <div className="alert bg-soft-primary fw-medium mt-4" role="alert">
          <FiInfo className="fs-5 align-middle me-1" /> El paciente no ha
          respondido a la encuesta de satisfacción
        </div>
      )}
    </>
  );
};
